import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { DatePipe, LocationStrategy } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/bufferCount';
import { SERVER, LOGON_INFO } from "./app.constants";
import { MessageService } from "./common/message.service";
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from 'file-saver';
// import { start } from "repl";
import $ from 'jquery';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import * as pdfjsLib from 'pdfjs-dist';

import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import { style } from "@angular/core/src/animation/dsl";

@Injectable()
export class CommonService {

    defaultTimezone: string = "+09:00";
    file_preview_type: string = undefined;
    file_preview_url: SafeUrl | string = undefined;
    file_download_path: string = undefined;
    file_download_filename: string = undefined;

    constructor(
        private _htc: HttpClient,
        private msgService: MessageService,
        private datePipe: DatePipe,
        public sanitizer: DomSanitizer
    ) {
        pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.min.js";
    }


    //全体コードリスト取得
    getAllCode() {
        this.getCodeList('LOAD_METHOD');
        this.getCodeList('TIME_DIVIDE');
        this.getCodeList('CAR_TYPE');
        this.getCodeList('CAR_MAKER');
        this.getCodeList('COMP_TYPE');
        this.getCodeList('CAR_ABILITY');
        this.getCodeList('CHARGE_UNIT');
        this.getCodeList('LICENSE_TYPE');
        this.getCodeList('CAR_MENU');
        this.getCodeList('STATE_MENU');
        this.getCodeList('STATE_CLTR');
    }


    //コードリスト取得
    getCodeList(code_div: string) {
        let params = new HttpParams().set('code_div', code_div);
        this._htc.get<Code[]>(SERVER.baseURL+'/common/code/', {params: params})
        .subscribe(
            // (2024.02)マルチセレクト対応（初期化）
            data => {
                if(code_div == 'CAR_TYPE' || code_div == 'CAR_MAKER') {
                    const codeList: Code[] = [];

                    for(let i=0; i<data.length; i++){
                        let cd: Code = Object.assign({}, data[i]);
                        cd.is_selected = false;
                        codeList.push(cd);
                    }

                    sessionStorage.setItem(code_div, JSON.stringify(codeList));
                } else if(code_div == 'CAR_MENU' || code_div == 'STATE_MENU') {
                    const codeList: Code[] = [];

                    for(let i=0; i<data.length; i++){
                        let cd: Code = Object.assign({}, data[i]);
                        cd.is_selected = true;
                        codeList.push(cd);
                    }

                    sessionStorage.setItem(code_div, JSON.stringify(codeList));
                } else {
                    sessionStorage.setItem(code_div, JSON.stringify(data));
                }
            }
        );
    }


    //郵便番号から住所を取得
    getAddress(zipcode: string): Observable<any> {
        let params = new HttpParams().set('postcode', zipcode);
        return this._htc.get('https://postcode-jp.appspot.com/api/postcode', {params: params});
    }


    searchAddress(search_text: string): Observable<Zipcode[]> {
        let params = new HttpParams().set('search', search_text);
        return this._htc.get<Zipcode[]>(SERVER.baseURL+'/common/zipcode/', {params: params});
    }

    getHoliday() {
        this._htc.get<Zipcode[]>(SERVER.baseURL+'/common/holiday/')
            .subscribe(
                data => sessionStorage.setItem('HOLIDAY', JSON.stringify(data['results']))
            );
    }

    getTodohuken() {
        this._htc.get<Zipcode[]>(SERVER.baseURL+'/common/todohuken/')
            .subscribe(
                data => sessionStorage.setItem('TODOHUKEN', JSON.stringify(data['results']))
            );
    }



    //////////// * LOADING SPINNER
    showLoading() {
        $('#loading ,#spinner').height($(window).height()).css('display','block');
    }
    hideLoading() {
        $('#loading').delay(400).fadeOut(300);
        $('#spinner').delay(300).fadeOut(300);
    }



    //////////// *
    //////////// * ＤＡＴＥ 関連
    //////////// *
    checkStartEndDate(start_date:any, start_time:string, end_date:any, end_time:string, isAllday:boolean, isSuppressPast:boolean, isSuppressFuture:boolean): boolean {
        let isValid = true;
        let now = new Date();         now.setHours(isAllday ? 0 : now.getHours(), 0, 0);
        let sd = start_date.jsdate;   sd.setHours(isAllday || !start_time ? 0 : +start_time, 0, 0);
        let ed = end_date.jsdate;     ed.setHours(isAllday || !end_time ? 0 : +end_time, 0, 0);

        if (isSuppressPast && (sd.getTime() < now.getTime() || ed.getTime() < now.getTime())) {
            this.msgService.addError("現在"+ (isAllday?"日付":"日時") +"より後の日付を入力してください。");
            isValid = false;
        }
        if ((isAllday && sd.getTime() > ed.getTime()) || (!isAllday && sd.getTime() >= ed.getTime())) {
            this.msgService.addError("開始日には終了日より前の" + (isAllday?"日付":"日時") + "を入力してください。");
            isValid = false;
        }
        if (isSuppressFuture) {
            ed.setDate(1);
            if (ed.getTime() > now.getTime() || sd.getTime() > now.getTime()) {
                this.msgService.addError("現在"+ (isAllday?"日付":"日時") +"より前の日付を入力してください。");
                isValid = false;
            }
        }

        return isValid;
    }

    isBetweenDate(targetDate:string, start_date:any, end_date:any): boolean {
        let td = new Date(targetDate);
        if ((!start_date || start_date.jsdate.getTime() <= td.getTime()) && (!end_date || td.getTime() <= end_date.jsdate.getTime())) {
            return true;
        }
        return false;
    }

    getDayOfWeek(d: Date) {
        return [ "日", "月", "火", "水", "木", "金", "土" ][d.getDay()];
    }

    getDateStrShort(d: Date) {  //mm/dd(week)
        return (d.getMonth()+1) + "/" + d.getDate() + "(" + this.getDayOfWeek(d) + ")";
    }

    getDateStr(d: Date) {  //yyyy-mm-dd
        return d.toLocaleDateString("ja-JP", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).split('/').join('-');
    }

    convertDate(timestamp: any, format: string, add_weekday?: boolean): string {
        let return_ymd: string = "";
        if (timestamp) {
            if (timestamp.seconds) {
                return_ymd = this.datePipe.transform(timestamp.seconds * 1000, format, this.defaultTimezone);
            }
            else if (typeof timestamp == "string") {
                return_ymd = this.datePipe.transform(new Date(timestamp), format, this.defaultTimezone);
            }
            else {
                return_ymd = this.datePipe.transform(timestamp, format, this.defaultTimezone);
            }
        }
        return return_ymd + (add_weekday ? "("+this.getDayOfWeek(new Date(return_ymd))+")" : "");;
    }

    addMonths(date: Date, months: number): Date {
        let resultDate = new Date(date.getTime());
        resultDate.setMonth(date.getMonth() + months);
        return resultDate;
    }

    addDays(date: Date, days: number): Date {
        let resultDate = new Date(date.getTime());
        resultDate.setDate(date.getDate() + days);
        return resultDate;
    }

    getDayCnt(start: Date, end: Date): number {
        return Math.ceil((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24);
    }
    ///////////////////////////////////////////////////////////






    ////// * ＥＸＣＥＬ出力

    //車両リストのEXCEL出力
    // printCarListExcel(printData: any[][], excelFileName: string): void {
    //     const ws_col_width: any[] = [];

    //     for (let i=0; i<printData.length; i++) {
    //         printData[i] = printData[i].map((obj: any) => {
    //             //値がnullの場合はEXCELに"null"とprintされる、空き文字列へ変更して置く
    //             if (!obj.v) {
    //                 obj = Object.assign(obj, { t: 's', v: '' });
    //             }

    //             //全CELLのfontと配線
    //             obj.s = {
    //                 ...obj.s,
    //                 font: { name: "メイリオ", sz: 10 },
    //                 border: {
    //                     right: { style: "hair", color: "000000" },
    //                     left: { style: "hair", color: "000000" },
    //                     top: { style: "hair", color: "000000" },
    //                     bottom: { style: "hair", color: "000000" }
    //                 }
    //             };

    //             //タイトルの背景色
    //             if (i == 0) {
    //                 obj.s = {
    //                     ...obj.s,
    //                     fill: {
    //                         patternType: "solid",
    //                         fgColor: { rgb: "b8cde3" },
    //                         bgColor: { rgb: "b8cde3" }
    //                     },
    //                     alignment: { horizontal: "center" },
    //                     font: { name: "メイリオ", sz: 10, bold: true },
    //                 }
    //             }

    //             //セルの横幅
    //             ws_col_width.push({ wch: 14 });

    //             return obj;
    //         });
    //     }

    //     const wb = XLSX.utils.book_new();
    //     const ws = XLSX.utils.aoa_to_sheet(printData);
    //     ws['!cols'] = ws_col_width;
    //     excelFileName += "_" + this.convertDate(new Date(), "yyyyMMdd");
    //     XLSX.utils.book_append_sheet(wb, ws, excelFileName);
    //     XLSX.writeFile(wb, excelFileName + ".xlsx");
    // }

    exportAsExcelFile(data: any[], excelFileName: string, isSkipHeader: boolean): void {
        const workbook: XLSX.WorkBook = { SheetNames: ['data'], Sheets: {}, Props: {} };
        workbook.Sheets['data'] = XLSX.utils.json_to_sheet(data, {skipHeader: isSkipHeader});
        this.printExcel(workbook, excelFileName);
    }

    private printExcel(workbook: XLSX.WorkBook, excelFileName: string) {
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        const excelBlob: Blob = new Blob([this.sheetToArrayBuffer(excelBuffer)], {type: "application/octet-stream"});
        const today = new Date();
        const date = today.toLocaleDateString().replace(/\//g,'');
        const time = today.toLocaleTimeString('en-GB').replace(/:/g,'');
        FileSaver.saveAs(excelBlob, excelFileName + '_' + date + '_' + time + ".xlsx");
    }

    private sheetToArrayBuffer(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    // (2023.08) New library test
    async printCarListExcelJs(columnData: any[], printData: any[][], excelFileName: string): Promise<void> {
        const workbook = new ExcelJS.Workbook();
        // excelFileName += "_" + this.convertDate(new Date(), "yyyyMMdd");

        const worksheet = workbook.addWorksheet(excelFileName, {
            pageSetup:{paperSize: 9, orientation:'landscape', fitToPage: true}
        });

        worksheet.columns = columnData;
        worksheet.insertRows(2, printData);

        for(let i=0; i < worksheet.columnCount; i++ ) {
            // console.log('getcell?', worksheet.getCell(`${String.fromCharCode(i + 65)}1`));
            // console.log('getcell?', worksheet.getCell(1, i+1));
            // const columnCell = worksheet.getCell(`${String.fromCharCode(i + 65)}1`);
            const columnCell = worksheet.getCell(1, i+1);
            columnCell.font = { size: 10, name:'メイリオ', bold: true };
            columnCell.alignment = { horizontal: 'center' };
            columnCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'cce6ff' }};
        }

        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), excelFileName + ".xlsx");
    }

    async printBillExportAsExcelJs(itemData: any[], taxData: any[], printData: any[][], siteArray: any[][], taxArray: any[][], siteIndex: any[], taxIndex: any[], isTax: boolean, fileName: string) {
        const chunkedData: any[][][] = [];
        for (let i=0; i<printData.length; i+=18) {
            const chunk = printData.slice(i, i+18);
            chunkedData.push(chunk);
        }
        // console.log('chunkedData?!', chunkedData);

        const workbook = new ExcelJS.Workbook();

        for (let d=0; d<chunkedData.length; d++) {
            // console.log('?!d?!', d);
            let total_include_tax = 0;
            let total_exclude_tax = 0;
            for (let t=0; t<chunkedData[d].length; t++) {
                if (isTax) {
                    chunkedData[d][t][7] ? total_include_tax += chunkedData[d][t][7] : null;
                } else {
                    if (chunkedData[d][t][2].includes('高速代'))        chunkedData[d][t][7] ? total_exclude_tax += chunkedData[d][t][7] : null;
                    else                                                chunkedData[d][t][7] ? total_include_tax += chunkedData[d][t][7] : null;
                }
            }

            const cmToInch = (cm: number) => cm / 2.54;
            const worksheet = workbook.addWorksheet('請求書ページ'+(d+1).toString(), {
                pageSetup: {
                    paperSize: 9,
                    scale: 90,
                    margins: {left: cmToInch(1), right: cmToInch(0), top: cmToInch(1.9), bottom: cmToInch(0.5), header: cmToInch(0.8), footer: cmToInch(0.8)},
                    printArea: 'A1:I82',
                    fitToPage: true,
                    fitToWidth: 1,
                    fitToHeight: 2
                }
            });

            // 共通の枠の設定
            const adjWidth = 0.64;
            // const adjWidth = 0;
            worksheet.getColumn('A').width = worksheet.getColumn('B').width = 4.38 + adjWidth;
            worksheet.getColumn('C').width = 15.25 + adjWidth;
            worksheet.getColumn('D').width = 19.38 + adjWidth;
            worksheet.getColumn('E').width = 8.13 + adjWidth;
            worksheet.getColumn('E').numFmt = '#,##0.0;[Red]-#,##0.0';
            worksheet.getColumn('F').width = 5.63 + adjWidth;
            worksheet.getColumn('G').width = 9.38 + adjWidth;
            worksheet.getColumn('G').numFmt = '#,##0;[Red]-#,##0';
            worksheet.getColumn('H').width = 14.38 + adjWidth;
            worksheet.getColumn('H').numFmt = '#,##0;[Red]-#,##0';
            worksheet.getColumn('I').width = 13.25 + adjWidth;

            for (let e=0; e<2; e++) {
                worksheet.getRow(1 + e*41).height = 18.75;
                const noCell = worksheet.getCell(1 + e*41, 9);
                noCell.value = '№　　　　　　　　';
                noCell.font = {name: 'ＭＳ Ｐゴシック', size: 11, underline: true};
                noCell.alignment = {vertical: 'middle'};

                worksheet.getRow(2 + e*41).height = 25.5;
                worksheet.mergeCells(2 + e*41, 1, 2 + e*41, 9);
                const titleCell = worksheet.getCell(2 + e*41, 1);
                titleCell.value = e==0 ? '　請　求　書　' : '　請　求　書　（控）';
                titleCell.font = {name: 'ＭＳ Ｐゴシック', size: 22, bold:true, underline: true};
                titleCell.alignment = {horizontal: 'center', vertical: 'middle'};

                worksheet.getRow(3 + e*41).height = worksheet.getRow(4 + e*41).height = 21;

                worksheet.getRow(5 + e*41).height = 25.5;
                worksheet.mergeCells(5 + e*41, 1, 5 + e*41, 4);
                const custCell = worksheet.getCell(5 + e*41, 1);
                custCell.value = '　殿';
                custCell.font = {name: 'ＭＳ 明朝', size: 14, bold:true};
                custCell.alignment = {horizontal: 'center', vertical: 'bottom'};
                custCell.border = {bottom: {style: 'thin'}};
                worksheet.mergeCells(5 + e*41, 8, 5 + e*41, 9);
                const addrCell = worksheet.getCell(5 + e*41, 8);
                addrCell.value = '青森県八戸市西白山台５丁目１３-１３';
                addrCell.font = {name: 'ＭＳ Ｐゴシック', size: 11};
                addrCell.alignment = {vertical: 'bottom', shrinkToFit: true};

                worksheet.getRow(6 + e*41).height = 18;
                worksheet.mergeCells(6 + e*41, 1, 6 + e*41, 4);
                const dateCell = worksheet.getCell(6 + e*41, 1);
                dateCell.value = new Date();
                dateCell.numFmt = 'yyyy年mm月dd日';
                dateCell.font = {name: 'ＭＳ 明朝', size: 11};
                dateCell.alignment = {horizontal: 'distributed', vertical: 'middle', indent: 2};    //元本確認必須！！
                worksheet.mergeCells(6 + e*41, 8, 6 + e*41, 9);
                const companyCell = worksheet.getCell(6 + e*41, 8);
                companyCell.value = '株式会社　　大　　　　興';
                companyCell.font = {name: 'ＭＳ Ｐ明朝', size: 14};
                companyCell.alignment = {vertical: 'middle'};

                worksheet.getRow(7 + e*41).height = 18.75;
                worksheet.mergeCells(7 + e*41, 1, 7 + e*41, 5);
                const infoCell = worksheet.getCell(7 + e*41, 1);
                infoCell.value = '　　下記のとおりご請求申し上げます。';
                infoCell.font = {name: 'ＭＳ 明朝', size: 12};
                infoCell.alignment = {vertical: 'middle'};
                worksheet.mergeCells(7 + e*41, 8, 7 + e*41, 9);
                const telCell = worksheet.getCell(7 + e*41, 8);
                telCell.value = '電話　　０１７８－２７－８１１１　';
                telCell.font = {name: 'ＭＳ Ｐ明朝', size: 11};
                telCell.alignment = {vertical: 'middle'};

                worksheet.getRow(8 + e*41).height = 18.75;
                worksheet.mergeCells(8 + e*41, 8, 8 + e*41, 9);
                const faxCell = worksheet.getCell(8 + e*41, 8);
                faxCell.value = 'FAX　　０１７８－２７－８１１８';
                faxCell.font = {name: 'ＭＳ Ｐ明朝', size: 11};
                faxCell.alignment = {vertical: 'middle'};

                worksheet.getRow(9 + e*41).height = 16.5;
                const tNumCell = worksheet.getCell(9 + e*41, 8);
                tNumCell.value = '登録番号　T2-4200-0100-6068';
                tNumCell.font = {name: 'ＭＳ Ｐ明朝', size: 11};
                tNumCell.alignment = {vertical: 'middle'};
                let tNumC = 1;
                while (tNumC < 10) {
                    worksheet.getCell(9 + e*41, tNumC).border = {bottom: {style: 'medium'}};
                    tNumC++;
                }

                worksheet.getRow(10 + e*41).height = worksheet.getRow(11 + e*41).height = 16.5;
                worksheet.mergeCells(10 + e*41, 1, 11 + e*41, 3);
                worksheet.mergeCells(10 + e*41, 4, 11 + e*41, 4);
                const totalCell = worksheet.getCell(10 + e*41, 1);
                totalCell.value = '　 　合計金額　　';
                totalCell.font = {name: 'ＭＳ 明朝', size: 16};
                totalCell.alignment = {vertical: 'bottom'};
                let totalC = 1;
                while (totalC < 10) {
                    worksheet.getCell(10 + e*41, totalC).border = {top: {style: 'medium'}};
                    worksheet.getCell(11 + e*41, totalC).border = {bottom: {style: 'medium'}};
                    totalC++;
                }

                worksheet.insertRow(12 + e*41, itemData);
                worksheet.mergeCells(12 + e*41, 1, 12 + e*41, 2);
                const itemRow = worksheet.getRow(12 + e*41);
                itemRow.height = 23.25;
                itemRow.font = {name: 'ＭＳ Ｐ明朝', size: 12};
                itemRow.alignment = {horizontal: 'center', vertical: 'middle'};
                let itemC = 1;
                while (itemC < 10) {
                    if (itemC == 2)                         worksheet.getCell(12 + e*41, itemC).border = {left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'hair'}};
                    else if (itemC == 7 || itemC == 8)      worksheet.getCell(12 + e*41, itemC).border = {bottom: {style: 'thin'}, right: {style: 'double'}};
                    else if (itemC == 9)                    worksheet.getCell(12 + e*41, itemC).border = {bottom: {style: 'thin'}, right: {style: 'thin'}};
                    else                                    worksheet.getCell(12 + e*41, itemC).border = {bottom: {style: 'thin'}, right: {style: 'hair'}};
                    itemC++;
                }

                // worksheet.insertRows(13, printData);
                worksheet.insertRows(13 + e*41, chunkedData[d]);
                for (let i=13 + e*41; i<31 + e*41; i++) {
                    worksheet.getRow(i).height = 23.25;
                    worksheet.mergeCells(i, 1, i, 2);
                    for (let j=1; j<10; j++) {
                        const dataCell = worksheet.getCell(i, j);
                        dataCell.alignment = {horizontal: 'center', vertical: 'middle', shrinkToFit: true};
                        if (j == 2)                     dataCell.border = {left: {style: 'thin'}, bottom: {style: i == 30 + e*41 ? 'medium' : 'hair'}, right: {style: 'hair'}};
                        else if (j == 7 || j == 8)      dataCell.border = {bottom: {style: i == 30 + e*41 ? 'medium' : 'hair'}, right: {style: 'double'}};
                        else if (j == 9)                dataCell.border = {bottom: {style: i == 30 + e*41 ? 'medium' : 'hair'}, right: {style: 'thin'}};
                        else                            dataCell.border = {bottom: {style: i == 30 + e*41 ? 'medium' : 'hair'}, right: {style: 'hair'}};
                        // dataCell.border = {left: {style: 'hair'}, bottom: {style: 'hair'}, right: {style: 'hair'}}
                        if (j == 5 || j == 7 || j == 8) {
                            dataCell.font = {name:'Century'};
                            dataCell.alignment = {horizontal: 'right', vertical: 'middle', shrinkToFit: true};
                        }
                    }
                }

                worksheet.getRow(31 + e*41).height = 12.75;

                worksheet.insertRow(32 + e*41, taxData);
                worksheet.getCell(33 + e*41, 3).value = '10%対象';
                // console.log('getValue?!', worksheet.getCell(33, 3).value);
                worksheet.getCell(33 + e*41, 4).value = total_include_tax;
                const taxes = worksheet.getCell(33 + e*41, 5).value = Math.floor(total_include_tax * 0.1);
                // worksheet.getCell(33, 5).value = Math.floor(total_include_tax * 0.1);
                worksheet.getCell(33 + e*41, 7).value = total_include_tax + taxes;
                worksheet.getCell(34 + e*41, 3).value = '非課税';
                worksheet.getCell(34 + e*41, 4).value = worksheet.getCell(34 + e*41, 7).value = total_exclude_tax;

                worksheet.getCell(10 + e*41, 4).value = total_include_tax + taxes + total_exclude_tax;
                worksheet.getCell(10 + e*41, 4).font = {name: 'ＭＳ 明朝', size: 16};
                worksheet.getCell(10 + e*41, 4).alignment = {horizontal: 'center', vertical: 'bottom'};
                worksheet.getCell(10 + e*41, 4).numFmt = '"￥"#,##0';

                for (let k=32 + e*41; k<36 + e*41; k++) {
                    worksheet.getRow(k).height = 22.5;
                    worksheet.mergeCells(k, 5, k, 6);
                    worksheet.mergeCells(k, 7, k, 8);
                    let kRow = worksheet.getRow(k);
                    kRow.font = {name: 'ＭＳ Ｐ明朝', size: 12};
                    if (k == 32 + e*41)        kRow.alignment =  {horizontal: 'center', vertical: 'middle'};
                    else {
                        kRow.alignment =  {horizontal: 'right', vertical: 'middle'};
                        kRow.numFmt = '#,##0';
                    }
                    for (let l=3; l<9; l++) {
                        const lCell = worksheet.getCell(k, l);
                        lCell.border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}};
                    }
                }
                worksheet.getRow(36 + e*41).height = 12.75;

                worksheet.getCell(37 + e*41, 2).value = '振込先';
                worksheet.getCell(38 + e*41, 3).value = worksheet.getCell(38 + e*41, 5).value = '㈱大興';
                worksheet.getCell(39 + e*41, 3).value = worksheet.getCell(39 + e*41, 5).value = 'カ)ダイコウ';
                worksheet.getCell(40 + e*41, 3).value = '青い森信用金庫　沼館支店';
                worksheet.getCell(40 + e*41, 5).value = '青森銀行　城下中央支店';
                worksheet.getCell(41 + e*41, 3).value = '当座　557688';
                worksheet.getCell(41 + e*41, 5).value = '当座　3866';
                for (let m=37 + e*41; m<42 + e*41; m++) {
                    worksheet.getRow(m).height = 18.75;
                    let mRow = worksheet.getRow(m);
                    mRow.font = {name: 'ＭＳ Ｐゴシック', size: 11};
                    mRow.alignment = {vertical: 'middle'};
                }
            }
        }

        // 運送一式シート
        if (siteArray.length > 0) {
            const worksheetSite = workbook.addWorksheet('運送一式', {pageSetup:{printArea: 'A:L', fitToPage: true, fitToWidth: 1, fitToHeight: 0}});

            worksheetSite.getColumn('K').numFmt = '#,##0';
            worksheetSite.getColumn('L').numFmt = '#,##0';
            let siteSum = 0;
            for(let s=0; s<siteArray.length; s++) {
                if (siteArray[s][siteArray[0].length - 1]) {
                    siteSum += siteArray[s][siteArray[0].length - 1];
                }
            }

            worksheetSite.insertRow(1, siteIndex);
            worksheetSite.insertRows(2, siteArray);
            worksheetSite.getCell(siteArray.length + 2, siteArray[0].length - 1).value = '合計';
            worksheetSite.getCell(siteArray.length + 2, siteArray[0].length).value = siteSum;
            worksheetSite.getCell(siteArray.length + 4, siteArray[0].length - 1).value = '消費税(10%)';
            worksheetSite.getCell(siteArray.length + 4, siteArray[0].length).value = Math.trunc(siteSum * 0.1);
            worksheetSite.getCell(siteArray.length + 5, siteArray[0].length - 1).value = '計';
            worksheetSite.getCell(siteArray.length + 5, siteArray[0].length).value = siteSum + Math.trunc(siteSum * 0.1);
        }

        // 高速代シート
        if (taxArray.length > 0) {
            const worksheetTax = workbook.addWorksheet('高速代', {pageSetup:{printArea: 'A:J', fitToPage: true, fitToWidth: 1, fitToHeight: 0}});

            worksheetTax.getColumn('J').numFmt = '#,##0';
            let taxSum = 0;
            for(let t=0; t<taxArray.length; t++) {
                if (taxArray[t][taxArray[0].length - 1]) {
                    taxSum += taxArray[t][taxArray[0].length - 1];
                }
            }

            worksheetTax.insertRow(1, taxIndex);
            worksheetTax.insertRows(2, taxArray);
            if (isTax) {
                worksheetTax.getCell(taxArray.length + 3, taxArray[0].length - 2).value = '合計';
                worksheetTax.getCell(taxArray.length + 3, taxArray[0].length - 1).value = taxSum + Math.trunc(taxSum * 0.1);
                worksheetTax.getCell(taxArray.length + 3, taxArray[0].length).value = taxSum;
                worksheetTax.getCell(taxArray.length + 4, taxArray[0].length - 1).value = '税額(10%)';
                worksheetTax.getCell(taxArray.length + 4, taxArray[0].length).value = Math.trunc(taxSum * 0.1);
            } else {
                worksheetTax.getCell(taxArray.length + 3, taxArray[0].length - 1).value = '合計';
                worksheetTax.getCell(taxArray.length + 3, taxArray[0].length).value = taxSum;
            }
        }


        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), "大興請求書_" + fileName + ".xlsx");
    }


    async printBillTotalExcelJs(columnData: any[], printData: any[][], excelFileName: string, cltrCount: number, compCount: number): Promise<void> {
        const columnTitle: string[] = ['請求書', '得意先', '請求額', '付帯事業収入', '付帯事業収入（その他）', '運送事業収入', '運送関連収入', 'その他内訳'];
        const workbook = new ExcelJS.Workbook();
        // excelFileName += "_" + this.convertDate(new Date(), "yyyyMMdd");

        // console.log('columnData?!', columnData);

        const worksheet = workbook.addWorksheet(excelFileName, {
            pageSetup:{paperSize: 9, orientation:'landscape', fitToPage: true}
        });

        // worksheet.columns = columnData;
        for (let i=0; i<columnTitle.length; i++) {
            switch (i) {
                case 0:
                case 1:
                case 2:
                case 3:
                    worksheet.mergeCells(1, i+1, 2, i+1);
                    worksheet.getCell(1, i+1).value = columnTitle[i];
                    break;
                case 4:
                    if (cltrCount> 0) {
                    worksheet.mergeCells(1, i+1, 1, i+cltrCount);
                    worksheet.getCell(1, i+1).value = columnTitle[i];
                    }
                    break;
                case 5:
                    if (compCount > 0) {
                        worksheet.mergeCells(1, i+cltrCount, 1, i+cltrCount+compCount-1);
                        worksheet.getCell(1, i+cltrCount).value = columnTitle[i];
                    }
                    break;
                case 6:
                    worksheet.mergeCells(1, i+cltrCount+compCount-1, 1, i+cltrCount+compCount);
                    worksheet.getCell(1, i+cltrCount+compCount-1).value = columnTitle[i];
                    break;
                default:
                    worksheet.mergeCells(1, i+cltrCount+compCount, 1, printData[0].length);
                    worksheet.getCell(1, i+cltrCount+compCount).value = columnTitle[i];
                    break;
            }
        }

        for (let i=0; i<columnData.length; i++) {
            worksheet.getCell(2, i+5).value = columnData[i];
        }
        worksheet.insertRows(3, printData);

        for(let j=0; j < worksheet.columnCount; j++ ) {
            // console.log('getcell?', worksheet.getCell(`${String.fromCharCode(i + 65)}1`));
            // console.log('getcell?', worksheet.getCell(1, j+1));
            // const columnCell = worksheet.getCell(`${String.fromCharCode(i + 65)}1`);
            if (j<2) {
                worksheet.getColumn(j+1).width = 25;
            }
            else {
                worksheet.getColumn(j+1).width = 12;
            }
            worksheet.getColumn(j+1).alignment = {shrinkToFit: true};

            const columnCell = worksheet.getCell(1, j+1);
            columnCell.font = { size: 10, name:'メイリオ', bold: true };
            columnCell.alignment = { horizontal: 'center', vertical: 'middle' };
            columnCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'cce6ff' }};
            columnCell.border = { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), excelFileName + ".xlsx");
    }
    ///////////////////////////////////////////////////////////////////////////////


    //小数点切り捨て
    decimalRound(coord: number, n: number): number {
        return coord? Math.round(coord * Math.pow(10, n)) / Math.pow(10, n) : null;
    }

    numToStr(num: number): string {
        return num? num.toString() : "";
    }



    //// *
    //// * ＦＩＬＥ　ＤＯＷＮＬＯＡＤ
    //// *
    async pdfPreview(_url: string, is_expansion_modal: boolean, _canvas_id?: string): Promise<void> {
        let renderTask;
        const pdf = await pdfjsLib.getDocument({url: _url}).promise;

        if (is_expansion_modal) {
            $("#filePreviewBody").empty();
            const viewer = document.getElementById("filePreviewBody");
            for(let page = 1; page <= pdf.numPages; page++) {
                const pdfPage = await pdf.getPage(page);
                const viewport = pdfPage.getViewport({ scale: 1.5 });
                const _canvas = document.createElement('canvas');
                _canvas.style.cssText = "font-weight: normal; width: 100%;";
                const canvasContext = _canvas.getContext('2d');
                _canvas.height = viewport.height;
                _canvas.width = viewport.width;
                viewer.appendChild(_canvas);
                renderTask = pdfPage.render({ canvasContext, viewport });
            }
        } else {
            const _canvas = $("#"+_canvas_id)[0]
            const pdfPage = await pdf.getPage(1);
            const viewport = pdfPage.getViewport({ scale: 0.5 });
            const canvasContext = _canvas.getContext('2d');
            _canvas.height = viewport.height;
            _canvas.width = viewport.width;
            renderTask = pdfPage.render({ canvasContext, viewport });
        }

        await renderTask.promise;
    }

    filePreviewModalShow(file_path: string, file_name: string, file_type?: string) {
        const token: string = sessionStorage.getItem("file_download_token");
        const url = SERVER.baseURL + "/common/file-preview/?file_path=" + file_path + "&token=" + token;
        this.file_preview_url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.file_download_path = file_path;
        this.file_download_filename = file_name;
        this.file_preview_type = file_type;
        if (file_type && file_type.toUpperCase() == "PDF") {
            this.pdfPreview(url, true);
        }
        $('#filePreviewModal').modal('show');
    }

    fileDownload(file_path: string | string[], file_name: string = undefined, condition: string = undefined) {
        this.showLoading();

        let httpClient = undefined;
        const form_data = new FormData();
        const origin_name = file_name;

        //単一ファイルダウンロードの場合
        if (typeof file_path == "string") {
            form_data.append("file_path", file_path);
            httpClient = this._htc.post<Blob>(SERVER.baseURL + "/common/file-download/", form_data, {responseType: 'blob' as 'json'});
        }
        // (2023.09)PDF一括ダウンロードの場合
        else if (file_name == "車両別PDF" || "車両別Link") {
            // file_name = file_name + "_" + this.convertDate(new Date(), "yyyyMMdd") + ".zip";
            file_name = "車両別PDF_" + LOGON_INFO.USER_ID + "_" + this.convertDate(new Date(), "yyyyMMdd") + ".zip";
            file_path.forEach((path: string) => form_data.append("file_path_list", path));
            form_data.append("file_name", file_name);

            if (origin_name == "車両別Link") {
                form_data.append("pdf_case", 'L');
                form_data.append("user_id", LOGON_INFO.USER_ID);
            } else      form_data.append("pdf_case", 'D');

            httpClient = this._htc.post<Blob>(SERVER.baseURL + "/common/pdf-file-download/", form_data, {responseType: 'blob' as 'json'});
        }
        // (2024.01)PDFリンクダウンロードの場合
        // else if (file_name == "車両別Link") {
        //     file_name = file_name + "_" + this.convertDate(new Date(), "yyyyMMdd") + ".zip";
        //     file_path.forEach((path: string) => form_data.append("file_path_list", path));
        //     httpClient = this._htc.post<Blob>(SERVER.baseURL + "/common/pdf-link-download/", form_data, {responseType: 'blob' as 'json'});
        // }
        //複数ファイル一括(ZIP)ダウンロードの場合
        else {
            file_name = file_name + "_" + this.convertDate(new Date(), "yyyyMMdd") + ".zip";
            file_path.forEach((path: string) => form_data.append("file_path_list", path));
            httpClient = this._htc.post<Blob>(SERVER.baseURL + "/common/multi-file-download/", form_data, {responseType: 'blob' as 'json'});
        }

        httpClient.subscribe(
            (response: any) => {
                if (origin_name == "車両別Link")        this.msgService.addInfo("ファイルの生成が始まりました。5分後にご確認お願い致します。");
                else {
                    const dataType = response.type;
                    const binaryData = [];
                    binaryData.push(response);
                    const downloadLink = document.createElement('a');
                    downloadLink.setAttribute('style', 'display: none');
                    downloadLink.href = URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                    if (file_name) {
                        downloadLink.setAttribute('download', file_name);
                    } else {
                        downloadLink.setAttribute('target', "_blank");
                    }

                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }

                this.hideLoading();
            },
            (err: any) => {
                this.hideLoading();
            }
        )
    }

    runScheduler() {
        this.showLoading();

        let httpClient = undefined;

        httpClient = this._htc.post<null>(SERVER.baseURL + "/common/tasks-background/", null);

        httpClient.subscribe(
            (response: any) => {
                this.hideLoading();
            },
            (err: any) => {
                this.hideLoading();
            }
        )
    }

    clear_preview_url() {
        this.file_preview_url = undefined;
        this.file_download_path = undefined;
        this.file_download_filename = undefined;
    }
    //// *

}





export class Code {
    code: string;
    name: string;
    extra_svalue_1?: string;
    extra_svalue_2?: string; // 列の文字揃え ('right' | 'left' | null=center)

    // (2024.02)マルチセレクト対応
    is_selected: boolean;
}

export class Zipcode {
    zipcode: string;
    todohuken: string;
    address: string;
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts